'use client';

import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { CheckboxToggle } from '../../../../../common/components/CheckboxToggle/CheckboxToggle';

const containerStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'medium',
  padding: 'small',
  bg: 'neutrals.fill_quinary',
  borderRadius: '8px',
  marginTop: 'medium',
});

const textContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',
  gap: 'extra_small_2',
  flex: 1,
});

const titleStyles = css({
  color: 'neutrals.text_primary',
  fontSize: 'label.medium_bold',
  fontWeight: 'label.medium_bold',
  lineHeight: 'label.medium_bold',
  letterSpacing: 'label.medium_bold',
});

const descriptionStyles = css({
  color: 'neutrals.text_primary',
  fontSize: 'caption.medium_medium',
  fontWeight: 'caption.medium_medium',
  lineHeight: 'caption.medium_medium',
  letterSpacing: 'caption.medium_medium',
});

interface AddSavingsPlanToggleProps {
  isEnabled: boolean;
  onToggle: (value: boolean) => void;
}

export const AddSavingsPlanToggle: FC<AddSavingsPlanToggleProps> = ({
  isEnabled,
  onToggle,
}) => {
  const { t } = useClientTranslation();

  return (
    <div className={containerStyles}>
      <div className={textContainerStyles}>
        <p id="add-savings-plan-title" className={titleStyles}>
          {t('add_savings_plan_toggle_title')}
        </p>

        <p id="add-savings-plan-description" className={descriptionStyles}>
          {t('add_savings_plan_toggle_description')}
        </p>
      </div>

      <CheckboxToggle
        aria-labelledby="add-savings-plan-title"
        aria-describedby="add-savings-plan-description"
        checked={isEnabled}
        variant="positive"
        onChange={(e) => onToggle(e.target.checked)}
      />
    </div>
  );
};
